import { H1 } from '@zimpel/common/components/Headlines';
import HintBox, { StyledBox } from '@zimpel/common/components/HintBox/HintBox';
import React from 'react';
import styled from 'styled-components';

const StyledBackground = styled.div`
  background-color: var(--color-gray-light);
  min-height: 100vh;
`;

const StyledContend = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 30px;
`;

const StyledHeadline = styled(H1)`
  margin-bottom: 20px;
`;

const StyledOptOutMessage = styled(StyledBox)`
  font-size: var(--font-size-large);
  text-align: left;
`;

type OptOutPageProps = {
  headline: string;
  message: string;
  hint?: string;
  hintHeader?: string;
}

const OptOutPage: React.FC<OptOutPageProps> = ({
  headline, message, hint, hintHeader,
}) => (
  <StyledBackground>
    <StyledContend>
      <StyledHeadline>{headline}</StyledHeadline>
      <StyledOptOutMessage>
        {message}
      </StyledOptOutMessage>
      {hint && hintHeader && (
        <HintBox header={hintHeader}>
          {hint}
        </HintBox>
      )}
    </StyledContend>
  </StyledBackground>
);

export default OptOutPage;
